export enum PharmacyLocationEnum {
  Setup = 0,
  Settings = 1,
}
